
const diplomasData = [
  {
    year: 2026,
    items: [
      { id: 100, title: 'Грамота 2026', file: '20260606.jpg', type: 'image' },
    ]
  },
  {
    year: 2025,
    items: [
      { id: 105, title: 'Грамота 2025', file: '2025.jpg', type: 'image' },
    ]
  },
  {
    year: 2023,
    items: [
      { id: 106, title: 'Грамота 2023', file: '2023.jpg', type: 'image' },
      { id: 107, title: 'Грамота 2023 (2)', file: '2023_.jpg', type: 'image' },
    ]
  },
  {
    year: 2022,
    items: [
      { id: 108, title: 'Грамота 2022', file: '2022.jpg', type: 'image' },
    ]
  },
  {
    year: 2019,
    items: [
      { id: 101, title: 'Грамота 2019', file: '20191212.jpg', type: 'image' },
    ]
  },
  {
    year: 2016,
    items: [
      { id: 102, title: 'Подяка 2016', file: '20160930.jpg', type: 'image' },
    ]
  },
  {
    year: 2011,
    items: [
      { id: 103, title: 'Грамота 2011', file: '20110629.jpg', type: 'image' },
    ]
  },
  {
    year: 2006,
    items: [
      { id: 104, title: 'Грамота 2006', file: '20061212.jpg', type: 'image' },
    ]
  }
];

export default diplomasData;
